import { render, staticRenderFns } from "./CbsWidgetBlank.vue?vue&type=template&id=082eb642&scoped=true"
import script from "./CbsWidgetBlank.vue?vue&type=script&lang=js"
export * from "./CbsWidgetBlank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082eb642",
  null
  
)

export default component.exports